export const NULL_STRING = "―";
export const DASH_SEPARATOR_STRING = " - ";
